import { ChangeDetectionStrategy, Component, computed, effect, untracked } from '@angular/core';
import { debounceTime, filter, startWith } from 'rxjs/operators';
import { InsuredObjectsBaseComponent } from '../../insured-objects-base-component';
import { toSignal } from '@angular/core/rxjs-interop';
import { InsuredObject } from '@models/insured-object';

@Component({
    selector: 'app-insured-objects',
    templateUrl: './insured-objects.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class InsuredObjectsComponent extends InsuredObjectsBaseComponent {
    protected settlementPeriod = computed(() => this.insuranceType().settlementPeriod);
    protected taxInfo = computed(() => this.product().orderConfig.taxInfo);

    protected additionalComponents = computed(() => this.product().insuredObjectsForm.additionalComponents);

    protected formValue = toSignal(
        this.form.controls.objects.valueChanges.pipe(
            startWith(this.form.controls.objects.value),
            debounceTime(300),
            filter((objects: InsuredObject[]) => objects.length > 0),
        ),
    );

    protected formGroups = computed(() => {
        this.formValue();

        return this.form.controls.objects.controls;
    });

    public constructor() {
        super();

        // update price when object form changes
        effect(() => {
            const insuredObjects = this.formValue();
            untracked(() => this.priceService.updatePrice({ insuredObjects }));
        });

        // update price when the product changes
        effect(() => {
            this.product();
            untracked(() => this.priceService.updatePrice({ insuredObjects: this.formValue() }));
        });

        // update the form when the state's insuredObjects changes
        effect(() => {
            this.insuredObjects();
            this.setupForm();
        });
    }

    public handleStateChange(): void {}
}
